function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../node_modules/_vue-loader@13.7.1@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-93ad5720\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=styles&index=0!./vDialog.vue")
}
var normalizeComponent = require("!../node_modules/_vue-loader@13.7.1@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=script&index=0!./vDialog.vue"
import __vue_script__ from "!!babel-loader!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=script&index=0!./vDialog.vue"
/* template */
import __vue_template__ from "!!../node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-93ad5720\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../node_modules/_vue-loader@13.7.1@vue-loader/lib/selector?type=template&index=0!./vDialog.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93ad5720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/vDialog.vue
// module id = 11
// module chunks = 0